import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { avatarSrc } from "@/lib/defaults";
import { prayingLabel, PRAYER_ACCENT } from "@/lib/prayers";
import { VerifiedBadge } from "@/components/VerifiedBadge";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogBody } from "@/components/ui/dialog";

// Avatar stack + « Marie, Paul et 5 autres prient » → tap opens the full list of intercessors.
export const Intercessors = ({ p, user }) => {
  const { t } = useApp();
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState(null);
  const preview = (p.intercessors || []).slice(0, 3);
  const label = prayingLabel(p, user, t);

  useEffect(() => {
    if (!open) return;
    setItems(null);
    api.get(`/prayers/${p.id}/intercessors`).then(({ data }) => setItems(data.items || [])).catch(() => setItems([]));
  }, [open, p.id]);

  if (!p.pray_count) {
    return <span className="text-xs" style={{ color: "var(--yalola-text-muted)" }} data-testid={`prayer-intercessors-${p.id}`}>{label}</span>;
  }
  return (
    <>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        className="inline-flex items-center gap-2 text-xs font-medium hover:underline text-left"
        style={{ color: "var(--yalola-text-muted)" }}
        data-testid={`prayer-intercessors-${p.id}`}
      >
        <span className="flex -space-x-2">
          {preview.map((u) => (
            <Avatar key={u.id || u.name} className="h-6 w-6 ring-2" style={{ "--tw-ring-color": "var(--yalola-surface)" }}>
              <AvatarImage src={avatarSrc(u, 32)} /><AvatarFallback className="text-[9px]">{u.name?.[0]}</AvatarFallback>
            </Avatar>
          ))}
        </span>
        <span>{label}</span>
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-sm" data-testid={`prayer-intercessors-dialog-${p.id}`}>
          <DialogHeader>
            <DialogTitle style={{ fontFamily: "Outfit" }}>{t("prayers.intercessors_title", "Ils prient pour cette demande")}</DialogTitle>
            <DialogDescription className="sr-only">{label}</DialogDescription>
          </DialogHeader>
          <DialogBody>
            {items === null && <div className="py-6 grid place-items-center"><Loader2 className="animate-spin" style={{ color: PRAYER_ACCENT }} /></div>}
            {items && (
              <ul className="divide-y" style={{ borderColor: "var(--yalola-border)" }}>
                {items.map((u) => (
                  <li key={u.id} className="py-2 flex items-center gap-2.5" data-testid={`prayer-intercessor-${u.id}`}>
                    <Avatar className="h-9 w-9"><AvatarImage src={avatarSrc(u)} /><AvatarFallback>{u.name?.[0]}</AvatarFallback></Avatar>
                    <Link to={`/profile/${u.id}`} className="text-sm font-semibold flex items-center gap-1 hover:underline" onClick={() => setOpen(false)}>
                      {u.name} <VerifiedBadge user={u} size={12} />
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </DialogBody>
        </DialogContent>
      </Dialog>
    </>
  );
};
